import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

export function getHeight(ref) {
  const element = ref.current;

  if (!element) {
    return 0;
  }

  const { height } = element.getBoundingClientRect();

  return height;
}

const withCalculateSticky = (Component) => {
  function WithCalculateStickyHOC(props) {
    const { stickyInfo, updateSticky, refOnTopSection, refOnToolbar } = props;

    const calculateSticky = useMemo(
      () => (topSectionHeight, toolbarHeight) => {
        const scrollValue = document.documentElement.scrollTop;
        const { isSticky: currentIsSticky } = stickyInfo;
        const nextIsSticky = scrollValue > topSectionHeight;

        if (currentIsSticky !== nextIsSticky) {
          updateSticky({
            isSticky: nextIsSticky,
            height: toolbarHeight,
            topSectionHeight,
          });
        }
      },
      [stickyInfo, updateSticky]
    );

    useEffect(() => {
      const scrollHandler = () => {
        const topSectionHeight = getHeight(refOnTopSection);
        const toolbarHeight = getHeight(refOnToolbar);
        calculateSticky(topSectionHeight, toolbarHeight);
      };

      document.addEventListener('scroll', scrollHandler, true);

      return () => {
        document.removeEventListener('scroll', scrollHandler, true);
      };
    }, [calculateSticky]);

    return <Component {...props} />;
  }

  WithCalculateStickyHOC.propTypes = {
    stickyInfo: PropTypes.shape({
      isSticky: PropTypes.bool,
      height: PropTypes.number,
      topSectionHeight: PropTypes.number,
    }).isRequired,
    updateSticky: PropTypes.func.isRequired,
    refOnTopSection: PropTypes.shape({
      current: PropTypes.instanceOf(Element),
    }).isRequired,
    refOnToolbar: PropTypes.shape({
      current: PropTypes.instanceOf(Element),
    }).isRequired,
  };

  return WithCalculateStickyHOC;
};

export default withCalculateSticky;
